import { ImageProps } from "./types";

export default function Image({
  alt = "dummy alt",
  ...otherProps
}: ImageProps) {
  return <img alt={alt} {...otherProps} />;
}
